module.exports = __webpack_public_path__ + "img/commissions.e062c29a.svg";